import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { GraduationCap } from 'lucide-react';
import { EmptyState, UploadButton } from './RecordHelpers';

export const OtherResourcesTab = ({ resources, term, onUploadOpen }) => (
  <div className="space-y-4">
    <div className="flex justify-end"><UploadButton tab="other-resources" defaultType="law" onOpen={onUploadOpen} /></div>
    {resources.filter(r => (r.title || '').toLowerCase().includes(term)).length === 0 ? (
      <EmptyState icon={GraduationCap} message={term ? 'No matches' : 'No resources yet'} sub="Relevant laws, rules, regulations, and training materials can be added from Secretariat Settings" />
    ) : (
      <div className="grid md:grid-cols-2 gap-3">
        {resources.filter(r => (r.title || '').toLowerCase().includes(term)).map(res => (
          <Card key={res.id} className="border-[#E2E6EA]" data-testid={`resource-${res.id}`}>
            <CardContent className="p-4 flex items-start gap-3">
              <div className="p-2 bg-[#F0F2F4] rounded-lg shrink-0"><GraduationCap className="h-5 w-5 text-[#6366f1]" /></div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-[#1A1D21] truncate">{res.title}</h4>
                {res.description && <p className="text-xs text-[#5A6570] mt-1 line-clamp-2">{res.description}</p>}
                <div className="flex items-center gap-2 mt-1.5">
                  {res.category && <Badge variant="outline" className="text-[10px] capitalize">{res.category}</Badge>}
                  {res.url && <a href={res.url} target="_blank" rel="noreferrer" className="text-[10px] text-[#00A3A3] hover:underline">Open</a>}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    )}
  </div>
);
